import { useCallback, useEffect, useRef } from 'react';
import ReactPixel from 'react-facebook-pixel';

const useFacebookPixel = (pixelId, options = {}) => {
  const hasInitialised = useRef(false);

  useEffect(() => {
    if (!pixelId || hasInitialised.current) {
      return;
    }

    try {
      ReactPixel.init(pixelId, undefined, options);
      hasInitialised.current = true;
      ReactPixel.pageView();
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('Facebook Pixel failed to initialise', error);
      }
    }
  }, [pixelId, options]);

  const trackPageView = useCallback(() => {
    if (hasInitialised.current) {
      ReactPixel.pageView();
    }
  }, []);

  const trackEvent = useCallback((eventName, data) => {
    if (hasInitialised.current) {
      ReactPixel.track(eventName, data);
    }
  }, []);

  return { trackPageView, trackEvent };
};

export default useFacebookPixel;
